<op-modal
  [title]="title"
  [btnClass]="btnClass"
  [showCloseButton]="showCloseButton"
  [cancelLabel]="cancelLabel"
>
  <!-- Content -->
  <modal-content>
    <p *ngIf="text" [innerHtml]="text | translate: titleParams"></p>
    <p *ngIf="whiteText" class="white-text" [innerHtml]="whiteText"></p>
  </modal-content>

  <!-- Actions -->
  <modal-actions-right *ngIf="!showCloseButton">
    <button
      class="btn btn-danger {{ btnClass }}"
      type="button"
      (click)="confirm()"
    >
      {{ confirmLabel ?? 'Conferma' }}
    </button>
  </modal-actions-right>
</op-modal>
